import { createFileRoute, redirect } from '@tanstack/react-router'
import { RulesetsListing } from 'features/rulesEngine'
import { z } from 'zod/v4'

import { AppRoute, buildRoute } from '../../../../../../appRoutes'
import { getLDFlag } from '../../../../../../helpers/launchDarkly'

const ruleSearchSchema = z.object({
  ruleStatus: z.string().optional(),
  searchQuery: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/rulesets/')({
  component: RulesetsListing,
  beforeLoad: ({ params, context }) => {
    const canViewRulesetBuilder = getLDFlag('RULESETS_AND_FLOW', false, context.ldClient)
    if (!canViewRulesetBuilder) {
      throw redirect({
        to: buildRoute(AppRoute.SubscriptionOverview, { subscriptionId: params.subscriptionId }),
      })
    }
  },
  validateSearch: z.object({
    ...ruleSearchSchema.shape,
  }),
})
